import { useQuery } from "@tanstack/react-query";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ApiError, getBootstrap } from "../api/client";
import { AppShell } from "../components/AppShell";
import { LoadingScreen } from "../components/ui";
import { LoginPage } from "../pages/LoginPage";
import { DashboardPage } from "../pages/DashboardPage";
import { TeamPage } from "../pages/TeamPage";
import { EventsPage } from "../pages/EventsPage";
import { ReportsPage } from "../pages/ReportsPage";
import { SchedulePage } from "../pages/SchedulePage";
import { RequestsPage } from "../pages/RequestsPage";
import { SettingsPage } from "../pages/SettingsPage";
import {
  AvailabilityPage,
  DelegationsPage,
  DevicesPage,
  IntegrationsPage,
  LocationsPage,
  NotificationsPage,
  RecordsPage,
  SelfServicePage,
  StatusesPage,
  TasksPage,
  TimeBankPage
} from "../pages/OperationsPages";
import { ReaderPage } from "../pages/ReaderPage";

const publicPaths = new Set(["/kiosk", "/czytnik-kart"]);

export function App() {
  const location = useLocation();
  const isPublic = publicPaths.has(location.pathname);
  const bootstrap = useQuery({
    queryKey: ["bootstrap"],
    queryFn: getBootstrap,
    enabled: !isPublic
  });

  if (isPublic) return <ReaderPage mode={location.pathname === "/kiosk" ? "kiosk" : "reader"} />;
  if (bootstrap.isLoading) return <LoadingScreen />;
  if (bootstrap.error instanceof ApiError && bootstrap.error.status === 401) return <LoginPage />;
  if (bootstrap.error) return <LoadingScreen error={bootstrap.error instanceof Error ? bootstrap.error.message : "Błąd połączenia"} />;
  if (!bootstrap.data) return <LoadingScreen />;

  return (
    <AppShell data={bootstrap.data}>
      <Routes>
        <Route path="/" element={<Navigate to="/app" replace />} />
        <Route path="/app" element={<DashboardPage data={bootstrap.data} />} />
        <Route path="/zespol" element={<TeamPage data={bootstrap.data} />} />
        <Route path="/grafik-pracy" element={<SchedulePage data={bootstrap.data} />} />
        <Route path="/kalendarz" element={<SchedulePage data={bootstrap.data} calendarOnly />} />
        <Route path="/dyspozycyjnosc" element={<AvailabilityPage data={bootstrap.data} />} />
        <Route path="/wnioski-urlopowe" element={<RequestsPage data={bootstrap.data} />} />
        <Route path="/delegacje" element={<DelegationsPage data={bootstrap.data} />} />
        <Route path="/zadania" element={<TasksPage data={bootstrap.data} />} />
        <Route path="/bank-czasu" element={<TimeBankPage data={bootstrap.data} />} />
        <Route path="/kartoteka" element={<RecordsPage data={bootstrap.data} />} />
        <Route path="/samoobsluga" element={<SelfServicePage data={bootstrap.data} />} />
        <Route path="/rcp/zdarzenia" element={<EventsPage data={bootstrap.data} />} />
        <Route path="/rcp/statusy-pracy" element={<StatusesPage data={bootstrap.data} />} />
        <Route path="/rcp/lokalizacje" element={<LocationsPage data={bootstrap.data} />} />
        <Route path="/rcp/urzadzenia" element={<DevicesPage data={bootstrap.data} />} />
        <Route path="/raporty/*" element={<ReportsPage data={bootstrap.data} />} />
        <Route path="/ustawienia" element={<SettingsPage data={bootstrap.data} />} />
        <Route path="/integracje" element={<IntegrationsPage data={bootstrap.data} />} />
        <Route path="/powiadomienia" element={<NotificationsPage data={bootstrap.data} />} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>
    </AppShell>
  );
}
